
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack, MdSave } from 'react-icons/md';
import './AddProduct.css'; // Reusing product form styles
import Swal from 'sweetalert2';
import axios from 'axios';
import { CREATE_PRODUCT_CATEGORY_API } from '../config/API';
import Loader from '../components/common/Loader';
import { showErrorToast } from '../utils/toastUtils';

const AddProductCategory = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        categoryName: '',
        status: 'active'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await Swal.fire({
            title: 'Save Category?',
            text: 'Do you want to save this product category?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Save',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#4f46e5',
            buttonsStyling: false,
            customClass: {
                confirmButton: 'swal-confirm-btn',
                cancelButton: 'swal-cancel-btn',
            },
        });

        if (result.isConfirmed) {
            try {
                setLoading(true);
                const token = localStorage.getItem('accessToken');
                const response = await axios.post(CREATE_PRODUCT_CATEGORY_API, formData, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (response.data.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Saved!',
                        text: 'Product category created successfully',
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    navigate('/product-categories');
                } else {
                    showErrorToast(response.data.error || response.data.message || 'Failed to create category');
                }
            } catch (error) {
                console.error('Error creating category:', error);
                const errorData = error.response?.data?.error || error.response?.data?.message || 'An error occurred';
                showErrorToast(errorData);
            } finally {
                setLoading(false);
            }
        }
    };

    if (loading) {
        return <Loader fullPage text="Creating category..." />;
    }

    return (
        <div className="add-product-page">
            <div className="page-header">
                <button onClick={() => navigate('/product-categories')} className="back-btn">
                    <MdArrowBack />
                </button>
                <h2>Add New Category</h2>
            </div>

            <form onSubmit={handleSubmit} className="product-form">
                <div className="form-section">
                    <h3>Category Information</h3>
                    <div className="form-grid">
                        <div className="form-group full-width">
                            <label>Category Name <span className="required-star">*</span></label>
                            <input
                                type="text"
                                name="categoryName"
                                value={formData.categoryName}
                                onChange={handleChange}
                                placeholder="e.g. Raw Materials"
                            />
                        </div>

                        <div className="form-group">
                            <label>Status</label>
                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <button type="button" onClick={() => navigate('/product-categories')} className="cancel-btn">
                        Cancel
                    </button>
                    <button type="submit" className="save-btn">
                        <MdSave /> Save Category
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddProductCategory;
